// Hold new session/API reads during the reset → sign-in session replacement.
// This gate is transient and stores no password, OTP or substitute session.
let generation = 0;
let completion: Promise<void> | null = null;
export async function withPasswordSessionTransition<T>(
  operation: () => Promise<T>,
): Promise<T> {
  if (completion) throw new Error("A password update is already in progress.");
  generation++;
  let release!: () => void;
  completion = new Promise<void>((resolve) => {
    release = resolve;
  });
  try {
    return await operation();
  } finally {
    completion = null;
    release();
  }
}
export function isPasswordSessionTransitionActive() {
  return completion !== null;
}
export async function waitForPasswordSessionTransition() {
  await completion;
}

export function getPasswordSessionGeneration() {
  return generation;
}
